export const COLUMNS = [
  {
    Header: "Topic",
    accessor: "Topic",
  },
  {
    Header: "Author",
    accessor: "Author",
  },
  {
    Header: "Date",
    accessor: "Date",
  },
];
